import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'filter',
    standalone: false
})
export class FilterPipe implements PipeTransform {

    transform(dataList: any, colName: string, searchValue: any): any {
        if (dataList && colName && searchValue) {
            return dataList.filter((val: any, index: number, obj: any) => {
                return val[colName] === searchValue;
            });
        }

        return dataList;
    }

}
